import CtaButtonGroup from '@/components/CtaSection/CtaButtonGroup/CtaButtonGroup';
import { SBImage } from '@/components/ImageService/SBImage';
import { Mindentity } from '@/components/Mindentity/Mindentity';
import { Typography } from '@/shared';
import { useThemeSection } from '@/shared/providers/SectionContext';
import { CtaButtonGroupStoryblok, MindStoryblok } from '@/shared/types/storyblok/storyblok-types';
import styles from './Author.module.scss';

const Author = ({
    authorTitle,
    author,
    isMobile,
    ctaButtonGroup,
    color,
}: {
    authorTitle: string;
    author: MindStoryblok;
    isMobile: boolean;
    ctaButtonGroup?: CtaButtonGroupStoryblok;
    color?: string;
}) => {
    const isDark = 'Dark' === useThemeSection();
    const { fullname, role, email, phoneNumber, linkedin, mind_color } = author?.content || {};

    return (
        <div className={styles.authorBox}>
            <Typography.ArticleQuote className={styles.title}>{authorTitle}</Typography.ArticleQuote>
            <div className={styles.author}>
                <div className={styles.image}>
                    {author.content?.portrait?.filename && isMobile && (
                        <SBImage
                            image={author.content?.portrait}
                            height={256}
                            fit="cover"
                            className={styles.authorImage}
                        />
                    )}
                    {author.content?.portrait?.filename && !isMobile && (
                        <Mindentity name={fullname || ''} color={mind_color?.color} isDark={isDark}>
                            <SBImage image={author.content?.portrait} width={256} height={256} />
                        </Mindentity>
                    )}
                </div>
                <div className={styles.infos}>
                    <div className={styles.top}>
                        <span className={styles.name}>{fullname}</span>
                        {fullname && role && <span className={styles.dot}>·</span>}
                        {role && <span className={styles.role}>{role}</span>}
                    </div>
                    <div className={styles.bottom}>
                        {email && (
                            <a href={`mailto:${email}`} className={styles.email}>
                                {email}
                            </a>
                        )}
                        {phoneNumber && (
                            <a href={`tel:${phoneNumber}`} className={styles.number}>
                                {phoneNumber}
                            </a>
                        )}
                        {linkedin && <div className={styles.linkedin}>{linkedin}</div>}
                    </div>
                    {ctaButtonGroup && ctaButtonGroup[0] && author?.content?.calendarId && (
                        <div className={styles.btnGroup}>
                            <CtaButtonGroup
                                blok={ctaButtonGroup[0]}
                                isDark={false}
                                color={color}
                                contactSlug={author.slug}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Author;
